import React from 'react';

function Icon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="234" height="333" version="1.1">
            <g transform="translate(0 -719.362)">
                <g>
                    <rect
                        width="233.244"
                        height="332.244"
                        x="0.378"
                        y="719.74"
                        fill="#fff"
                        fillOpacity="1"
                        stroke="gray"
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit="4"
                        strokeOpacity="1"
                        strokeWidth="0.756"
                        rx="8.919"
                        ry="8.946"
                    ></rect>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(.9761 1.02449)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M27.272 729.365q0 4.092-2.903 6.222-2.546 1.867-6.77 1.867-4.185 0-6.73-1.999-2.79-2.206-2.79-6.278 0-4.28 4.506-6.297-3.47-2.206-3.47-6.298 0-3.6 2.829-5.354 2.319-1.433 6.108-1.433 3.45 0 5.675 1.678 2.452 1.885 2.452 5.241 0 3.846-3.45 6.147 4.543 1.923 4.543 6.504zm-5.864-11.934q0-3.526-3.77-3.526-1.716 0-2.734.924-1.018.905-1.018 2.602 0 1.64 1.074 2.602 1.018.942 2.678.942 1.621 0 2.696-.961 1.074-.962 1.074-2.583zm.887 11.765q0-1.961-1.34-3.092-1.262-1.075-3.26-1.075-1.962 0-3.225 1.093-1.357 1.15-1.357 3.074 0 2.017 1.32 3.13 1.225 1.037 3.28 1.037 2.036 0 3.262-1.056 1.32-1.113 1.32-3.111z"
                            fontSize="38.613"
                        ></path>
                    </g>
                    <g
                        style={{ lineHeight: '0%' }}
                        fill="#000"
                        fillOpacity="1"
                        stroke="none"
                        strokeWidth="1"
                        fontFamily="Levenim MT"
                        fontSize="3.772"
                        fontStretch="normal"
                        fontStyle="normal"
                        fontVariant="normal"
                        fontWeight="bold"
                        letterSpacing="0"
                        transform="scale(-.97855 -1.02192)"
                        wordSpacing="0"
                    >
                        <path
                            style={{ lineHeight: '1.25' }}
                            strokeWidth="1"
                            d="M-211.925-1002.524q0 4.102-2.911 6.238-2.552 1.87-6.786 1.87-4.196 0-6.748-2.003-2.797-2.211-2.797-6.294 0-4.29 4.517-6.313-3.477-2.212-3.477-6.313 0-3.61 2.835-5.368 2.325-1.437 6.124-1.437 3.459 0 5.69 1.682 2.457 1.89 2.457 5.255 0 3.856-3.46 6.162 4.556 1.928 4.556 6.521zm-5.879-11.965q0-3.534-3.78-3.534-1.72 0-2.74.926-1.021.907-1.021 2.608 0 1.645 1.077 2.609 1.02.945 2.684.945 1.626 0 2.703-.964t1.077-2.59zm.889 11.795q0-1.966-1.342-3.1-1.267-1.077-3.27-1.077-1.966 0-3.232 1.096-1.361 1.153-1.361 3.081 0 2.022 1.323 3.138 1.228 1.04 3.289 1.04 2.041 0 3.27-1.06 1.323-1.114 1.323-3.118z"
                            fontSize="38.711"
                        ></path>
                    </g>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M12.899 780.702c0-.556-.031-.958-.031-1.514h3.545v-2.737c-2.244.072-4.673.24-6.774-.687-1.627-.893-2.076-2.97-1.748-4.68.281-1.927 1.353-3.638 2.75-4.957 1.82-1.946 4.14-3.26 6.562-4.316 2.472 1.075 4.843 2.431 6.685 4.428 1.66 1.56 2.765 3.764 2.731 6.071.036 1.665-.995 3.425-2.697 3.789-1.904.527-3.83.434-5.785.352v2.737h3.353c0 .556.03.958.03 1.514a665.864 665.864 0 00-8.621 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M212.488 991.022c0 .556-.031.958-.031 1.514h3.545v2.737c-2.244-.072-4.673-.239-6.774.687-1.627.893-2.076 2.971-1.748 4.68.28 1.927 1.352 3.639 2.75 4.957 1.82 1.946 4.14 3.26 6.562 4.316 2.472-1.075 4.843-2.431 6.685-4.428 1.66-1.56 2.765-3.763 2.731-6.07.036-1.666-.996-3.426-2.697-3.79-1.904-.527-3.83-.433-5.785-.352v-2.737h3.353c0-.556.03-.958.03-1.514-2.632.019-5.778.019-8.621 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M104.08 907.587c0 1.668-.093 2.873-.093 4.541h10.635v8.212c-6.732-.217-14.018-.717-20.322 2.06-4.88 2.679-6.227 8.913-5.243 14.039.842 5.782 4.057 10.917 8.25 14.872 5.458 5.838 12.418 9.778 19.684 12.949 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.295-11.29 8.193-18.212.108-4.996-2.987-10.276-8.092-11.366-5.711-1.582-11.492-1.301-17.354-1.057v-8.212h10.058c0-1.668.092-2.873.092-4.541-7.897.055-17.336.055-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 814.076c0-1.668-.093-2.873-.093-4.541h10.634v-8.211c-6.732.216-14.017.716-20.321-2.061-4.88-2.679-6.227-8.913-5.243-14.038.842-5.783 4.057-10.918 8.25-14.873 5.458-5.838 12.418-9.778 19.684-12.949 7.417 3.224 14.53 7.294 20.057 13.285 4.978 4.678 8.295 11.29 8.193 18.212.108 4.996-2.987 10.276-8.093 11.367-5.71 1.581-11.49 1.3-17.354 1.057v8.21h10.058c0 1.67.093 2.874.093 4.542-7.897-.055-17.336-.055-25.866 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 814.076c0-1.668-.092-2.873-.092-4.541h10.634v-8.211c-6.732.216-14.018.716-20.322-2.061-4.88-2.679-6.226-8.913-5.242-14.038.842-5.783 4.056-10.918 8.25-14.873 5.458-5.838 12.417-9.778 19.684-12.949 7.417 3.224 14.53 7.294 20.057 13.285 4.978 4.678 8.294 11.29 8.192 18.212.108 4.996-2.987 10.276-8.092 11.367-5.711 1.581-11.491 1.3-17.354 1.057v8.21h10.058c0 1.67.092 2.874.092 4.542-7.896-.055-17.336-.055-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M104.08 864.137c0-1.668-.093-2.873-.093-4.54h10.635v-8.212c-6.732.217-14.018.717-20.322-2.061-4.88-2.678-6.227-8.913-5.243-14.038.842-5.783 4.057-10.918 8.25-14.873 5.458-5.837 12.418-9.778 19.684-12.949 7.417 3.225 14.53 7.294 20.057 13.285 4.978 4.678 8.295 11.29 8.193 18.212.108 4.997-2.987 10.277-8.092 11.367-5.711 1.581-11.492 1.3-17.354 1.057v8.211h10.058c0 1.668.092 2.873.092 4.541-7.897-.055-17.336-.055-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 914.199c0-1.669-.093-2.873-.093-4.542h10.634v-8.211c-6.732.217-14.017.717-20.321-2.061-4.88-2.678-6.227-8.913-5.243-14.038.842-5.783 4.057-10.918 8.25-14.873 5.458-5.837 12.418-9.778 19.684-12.948 7.417 3.224 14.53 7.293 20.057 13.285 4.978 4.677 8.295 11.289 8.193 18.211.108 4.997-2.987 10.277-8.093 11.367-5.71 1.582-11.49 1.301-17.354 1.057v8.211h10.058c0 1.669.093 2.873.093 4.542-7.897-.056-17.336-.056-25.866 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 914.199c0-1.669-.092-2.873-.092-4.542h10.634v-8.211c-6.732.217-14.018.717-20.322-2.061-4.88-2.678-6.226-8.913-5.242-14.038.842-5.783 4.056-10.918 8.25-14.873 5.458-5.837 12.417-9.778 19.684-12.948 7.417 3.224 14.53 7.293 20.057 13.285 4.978 4.677 8.294 11.289 8.192 18.211.108 4.997-2.987 10.277-8.092 11.367-5.711 1.582-11.491 1.301-17.354 1.057v8.211h10.058c0 1.669.092 2.873.092 4.542-7.896-.056-17.336-.056-25.865 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M45.71 957.648c0 1.668-.093 2.873-.093 4.541h10.634v8.212c-6.732-.217-14.017-.717-20.321 2.06-4.88 2.679-6.227 8.913-5.243 14.039.842 5.782 4.057 10.918 8.25 14.873 5.458 5.837 12.418 9.778 19.684 12.948 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.295-11.29 8.193-18.212.108-4.996-2.987-10.276-8.093-11.366-5.71-1.582-11.49-1.301-17.354-1.057v-8.212h10.058c0-1.668.093-2.873.093-4.54-7.897.055-17.336.055-25.866 0z"
                    ></path>
                    <path
                        fill="#000"
                        stroke="none"
                        strokeWidth="1"
                        d="M162.45 957.648c0 1.668-.092 2.873-.092 4.541h10.634v8.212c-6.732-.217-14.018-.717-20.322 2.06-4.88 2.679-6.226 8.913-5.242 14.039.842 5.782 4.056 10.918 8.25 14.873 5.458 5.837 12.417 9.778 19.684 12.948 7.417-3.224 14.53-7.294 20.057-13.285 4.978-4.678 8.294-11.29 8.192-18.212.108-4.996-2.987-10.276-8.092-11.366-5.711-1.582-11.491-1.301-17.354-1.057v-8.212h10.058c0-1.668.092-2.873.092-4.54-7.896.055-17.336.055-25.865 0z"
                    ></path>
                </g>
            </g>
        </svg>
    );
}

export default Icon;
